import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { InvoiceEventViewModel, InvoiceViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { InvoiceState } from './types/InvoiceState';
import { getBgNumber, getInvoiceEvents, getInvoices } from './invoiceThunks';

const initialState: InvoiceState = {
  loadingInvoices: ThunkRequestStatus.Pending,
  loadingBgNumber: ThunkRequestStatus.Pending,
  invoices: [],
  bgNumber: '',
  error: '',
};

export type GetInvoiceEventsPayloadAction = {
  invoiceNumber: string;
  eventList: InvoiceEventViewModel[];
};

const slice = createSlice({
  initialState,
  name: 'invoiceSlice',
  reducers: {},
  extraReducers: builder => {
    // Get invoices
    builder.addCase(getInvoices.fulfilled, (state, action: PayloadAction<InvoiceViewModel[] | undefined>) => {
      if (action.payload) {
        state.loadingInvoices = ThunkRequestStatus.Fulfilled;
        state.invoices = action.payload;
      }
    });
    builder.addCase(getInvoices.pending, state => {
      state.loadingInvoices = ThunkRequestStatus.Pending;
    });
    builder.addCase(getInvoices.rejected, state => {
      state.loadingInvoices = ThunkRequestStatus.Rejected;
    });
    // Get invoice details
    builder.addCase(
      getInvoiceEvents.fulfilled,
      (state, action: PayloadAction<GetInvoiceEventsPayloadAction | undefined>) => {
        if (action.payload) {
          state.invoices = state.invoices.map(invoice => {
            if (invoice.invoiceNumber === action.payload?.invoiceNumber) {
              return {
                ...invoice,
                events: action.payload?.eventList,
              };
            } else {
              return invoice;
            }
          });
        }
      }
    );
    // Get BG number
    builder.addCase(getBgNumber.fulfilled, (state, action: PayloadAction<string | undefined>) => {
      if (action.payload) {
        state.loadingBgNumber = ThunkRequestStatus.Fulfilled;
        state.bgNumber = action.payload;
      }
    });
    builder.addCase(getBgNumber.pending, state => {
      state.loadingBgNumber = ThunkRequestStatus.Pending;
    });
    builder.addCase(getBgNumber.rejected, state => {
      state.loadingBgNumber = ThunkRequestStatus.Rejected;
    });
  },
});

export const invoiceReducer = slice.reducer;
